import React from "react";
import { useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import dashboardRoutes from "../../routes/dashboard.jsx";
import {
  getRegenerateToken,
  resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";
import { useSelector, useDispatch } from "react-redux";

function BreadCrumb(props) {

  const dispatch = useDispatch();

  const {
    data: { customerId, AuthToken, partnerId },
  } = useSelector((state) => state.login);

  const getdashboard = () => {
    if (props.service === "account") {
      return "/index/account-management";
    } else if (props.service === "wallet") {
      return "/index/fraud&risk-management";
    } else if (props.service === "voucher") {
      return "/index/voucher-management";
    } else if (props.service === "marketplace") {
      return "/index/currency-management";
    } else if (props.service === "prepaidcard") {
      return "/index/wallet-management";
    } else if (props.service === "limitmanagement") {
      return "/index/limit-management";
    } else if (props.service === "kycmanagement") {
      return "/index/kyc-management";
    } else if (props.service === "feeManagement") {
      return "/index/fee-management";
    } else if (props.service === "invoiceManagement") {
      return "/index/invoice-management";
    } else if (props.service === "userManagement") {
      return "/index/user-management";
    } else if (props.service === "userManagementAdmin") {
      return "/index/user-managementAdmin";
    } else if (props.service === "gatewayManagement") {
      // return "/index/gateway-management"; /index/transaction-management
      return "/index/transaction-management";
    } else if (props.service === "walletOwnerManagement") {
      return "/index/walletOwnerManagement";
    } else if (props.service === "GatewayManagement") {
      return "/index/Gateway-Management";
    } else if (props.service === "settlementmanagement") {
      return "/index/settlement-management";
    } else if (props.service === "adminFraudRiskManagement") {
      return "/index/AdminFraudRisk-Management";
    } else if (props.service === "adminCurrencyManagement") {
      return "/index/AdminCurrency-Management";
    } else if (props.service === "adminWalletManagement") {
      return "/index/AdminWallet-Management";
    } else if (props.service === "adminKycManagement") {
      return "/index/AdminKyc-Management";
    } else if (props.service === "adminFeeMaster") {
      return "/index/AdminFee-Master";
    } else if (props.service === "settings") {
      return "/index/settings";
    } else if (props.service === "cashLifting") {
      return "/index/cash-Lifting";
    } else if (props.service === "withdrawEMoney") {
      return "/index/withdraw-money";
    } else if (props.service === "agentDealerMapping") {
      return "/index/agent-Dealer-Map";
    } else if (props.service === "dealerProfile") {
      return "/index/dealerProfile";
    } else if (props.service === "dealerDSRManagement") {
      return "/index/dealerDSRManagement";
    } else if (props.service === "dealerCashLifting") {
      return "/index/dealerCashLifting";
    } else if (props.service === "dealerWithdrawEMoney") {
      return "/index/dealerWithdrawEMoney";
    } else if (props.service === "dealerPendingRequest") {
      return "/index/dealerPendingRequest";
    } else if (props.service === "dealerWalletManagement") {
      return "/index/dealerWalletManagement";
    } else if (props.service === "dealerUserManagement") {
      return "/index/dealerUserManagement";
    } else if (props.service === "dealerAgentMaster") {
      return "/index/dealerAgentMaster";
    }
    else return "/index/dashboard"; // ✅ safe fallback
  };

  const getBrand = () => {
    var name;
    dashboardRoutes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === props.location.pathname) {

            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === props.location.pathname) {

            name = prop.name;
          }
        } else {
          if (prop.path === props.location.pathname) {

            name = prop.name;
          }
        }
      }
      return null;
    });

    return name;
  };

  const getbreadcrumb = () => {
    var name;
    dashboardRoutes.map((prop, key) => {
      if (props.componentPath === prop.path) {
        name = prop.name;

      }
    });
    return name;
  };

  useEffect(() => {
    regenerateToken();
    getBrand();
    getbreadcrumb();
  }, [props]);

  const regenerateToken = () => {
    const regenerateTokenReq = {
      authentication: {
        partnerId: partnerId,
      },
      authToken: AuthToken,
    };

    return dispatch(getRegenerateToken(regenerateTokenReq));
  };

  return (
    <div style={{ marginTop: "90px" }} className="bread-crumb">
      {getdashboard() && (
        <Link to={getdashboard()}>{props.servicename}</Link>
      )}
      {props.componentPath === undefined || getBrand() === "Dashboard"
        ? ""
        : " / "}
      {/* ✅ Guard against undefined componentPath */}
      {props.componentPath && (
        <Link to={props.componentPath}>
          {getBrand() === "Dashboard" ? "" : getbreadcrumb()}
        </Link>
      )}
      {/* ✅ Guard against undefined getBrand() */}
      {getbreadcrumb() === getBrand()
        ? ""
        : getBrand() ? " / " + getBrand() : ""  // ✅ no more " / undefined"
      }
    </div>
  );
}

export default BreadCrumb;
